// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1LsmC","buttons":"Footer_buttons__2wdUN"};